<template>
    <b-modal no-close-on-backdrop ref="billingModal" id="billing-modal" :title="modalTitle" hide-footer>
        <p class="text-center" v-if="!hasTenant && !specificService">These verification steps are required before creating resources.</p>
        <f-fuga-usage v-if="showFugaUsage"/>
        <f-personal-details v-if="showFormPersonalDetails"/>
        <f-business-details v-if="showFormBusinessDetails"/>
        <f-billing-address v-if="showFormBillingAddress"/>
        <f-add-voucher v-if="showAddVoucher"/>
        <f-add-payment-method v-if="showAddPaymentMethod"/>
        <f-add-credit-card v-if="showFormCreditCard"/>
        <f-add-sepa-direct-debit v-if="showFormSepaDD"/>
        <f-add-sepa-sofort v-if="showFormSepaSofort"/>
        <f-address v-if="showFormAddress"/>
        <f-form-level v-if="showFormLevel"/>
        <f-form-present v-if="showFormPresent"/>
    </b-modal>
</template>

<script>
const fFugaUsage = () => import('@/components/registration/f-fuga-usage');
const fPersonalDetails = () => import('@/components/registration/f-personal-details');
const fBusinessDetails = () => import('@/components/registration/f-business-details');
const fBillingAddress = () => import('@/components/registration/f-billing-address');
const fAddVoucher = () => import('@/components/forms/f-add-voucher-form');
const fAddPaymentMethod = () => import('@/views/billing/f-add-payment-method');
const fAddCreditCard = () => import('@/views/billing/f-add-credit-card');
const fAddSepaDirectDebit = () => import('@/views/billing/f-add-sepa-direct-debit');
const fAddSepaSofort = () => import('@/views/billing/f-add-sepa-sofort');
const fAddress = () => import('@/components/registration/f-address');
const fFormPresent = () => import('@/components/registration/f-form-present');
const fFormLevel = () => import('@/components/registration/f-form-level');

export default {
    computed: {
        modalTitle() {
            if (this.showFormLevel) {
                return '';
            } else {
                return 'Enter billing details';
            }
        },

        showFugaUsage() {
            return this.$store.state.form.showFugaUsage;
        },

        showFormPersonalDetails() {
            return this.$store.state.form.showFormPersonalDetails;
        },

        showFormBusinessDetails() {
            return this.$store.state.form.showFormBusinessDetails;
        },

        showFormBillingAddress() {
            return this.$store.state.form.showFormBillingAddress;
        },

        showAddPaymentMethod() {
            return this.$store.state.form.showAddPaymentMethod;
        },

        showAddVoucher() {
            return this.$store.state.form.showAddVoucher;
        },

        showFormCreditCard() {
            return this.$store.state.form.showFormCreditCard;
        },

        showFormSepaDD() {
            return this.$store.state.form.showFormSepaDD;
        },

        showFormSepaSofort() {
            return this.$store.state.form.showFormSepaSofort;
        },

        showFormAddress() {
            return this.$store.state.form.showFormAddress;
        },

        showFormLevel() {
            return this.$store.state.form.showFormLevel;
        },

        showFormPresent() {
            return this.$store.state.form.showFormPresent;
        },
    },

    components: {
        fFugaUsage,
        fPersonalDetails,
        fBusinessDetails,
        fBillingAddress,
        fAddPaymentMethod,
        fAddCreditCard,
        fAddSepaDirectDebit,
        fAddSepaSofort,
        fAddress,
        fFormPresent,
        fFormLevel,
        fAddVoucher,
    }
}
</script>
